export default __webpack_public_path__ + "static/media/planets.699e7b21.PNG";